<template>
    <div class="main">
        <div class="listcontent">
            <div class="width50 blocklist left">
                <div class="btop bgw">
                    <h2 class="left btitle">Blocks</h2>
                    <a class="allbtn right" @click="changeRoute('/blockList')">View All</a>
                    <div class="clear"></div>
                </div>
                <div class="bcontent">
                    <div class="binfo bgw" v-for="block in blockList">
                        <div class="left" style=" margin-right:20px;padding: 7px 10px 4px;text-align:center;background-color:gray;width: 135px; height: 55px; margin-top:2px">
                            <span style="display: block;font-size: 22px;font-weight: 400;line-height: 25px;">
                                <a class="linkblock" @click="changeRoute('/blockDetail', {number: block.number})" style="text-decoration: none;">
                            <font size="2" color="white">Block {{ block.number }}</font></a>
                            </span>
                            <span style="margin-top:5px;font-size: 12px;line-height: 1.6;color: #fff;font-weight: 200;">{{ block.m }}{{ block.s }} ago </span>
                        </div>
                        <div class="left" style="margin-top:1px;">
                            <p class="blockinfo">mined by ETSC_Miner
                            </p>
                            <p class="blockinfo"><a @click="changeRoute('/transactionList', {number: block.number})">{{ block.transactions.length }} transactions</a> in this block</p>
                            <p class="blockinfo">size : {{ block.size | fmoney }} bytes</p>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
            <div class="width50 tranlist right">
                <div class="btop bgw">
                    <h2 class="left btitle">Transactions</h2>
                    <a class="allbtn right" @click="changeRoute('/transactionList')">View All</a>
                    <div class="clear"></div>
                </div>
                <div class="bcontent">
                    <div class="bgw" v-for="tran in transactionList" style="margin-top: 2px;padding:10px 0;">
                        <div class="left" style="display: block;height:25px;line-height:25px;font-size: 20px;font-weight: 400;padding: 0px 12px;margin-top: 5px;">
                            <img src="@/assets/img/ico.png" width="25px;">
                        </div>
                        <div class="left" style="margin-top: 1px;">
                            <p class="blockinfo" style="font-size: 14px; font-weight: 400;">TX#
                                <a @click="changeRoute('/transactionDetail', {hash: tran.hash})" title="">{{ addressSub(tran.hash, 15) }}</a></p>
                            <p class="blockinfo">
                                From<a @click="changeRoute('/transactionList', {addr: tran.from})"
                                       :title="tran.from">{{ addressSub(tran.from) }}</a>
                                To <a @click="changeRoute('/transactionList', {addr: tran.to})"
                                      :title="tran.to">{{ addressSub(tran.to) }}</a>
                            </p>
                            <p class="blockinfo">Amount {{ tran.value | roundOff(2) }} ETSC</p>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'home',
        data() {
            return {
                blockList: [],
                transactionList: [],
                it: "",
                loading1: false,
                loading2: false
            }
        },
        mounted() {
            this.getBlockList();
            this.getTransactionList();
            this.it = setInterval(() => {
                this.getCountDown();
            }, 1000);
        },

        destroyed() {
            if (this.it) {
                clearInterval(this.it);
            }
        },
        methods: {
            //投注
            getBlockList() {
                if (this.loading1) return;
                this.loading1 = true;
                return axios.get(this.requestConfig.apiHost + '/client/explore/block/list', {
                    params: {
                        pageNo: 1,
                        pageSize: 12
                    }
                }).then((response) => {
                    if (response.data.error_code != 0) {
                        throw new Error("get list error");
                    }
                    let now = parseInt((new Date().getTime() / 1000).toString());
                    let list = response.data.data
                    for (let i in list) {
                        let timeL = now - list[i].timestamp;
                        let mL = parseInt((timeL / 60).toString());
                        let sL = parseInt((timeL - 60 * mL).toString());
                        mL > 0 ? mL = mL + " minute" : mL = '';
                        sL > 0 ? sL = sL + " secs" : sL = '';

                        list[i].m = mL;
                        list[i].m = sL;
                    }
                    this.blockList = list;
                    this.loading1 = false;
                }).catch((error) => {
                    console.log(error);
                });
            },

            getTransactionList() {
                if (this.loading2) return;
                this.loading2 = true;
                return axios.get(this.requestConfig.apiHost + '/client/explore/transaction', {
                    params: {
                        pageNo: 1,
                        pageSize: 12,
                        type: "list"
                    }
                }).then((response) => {
                    if (response.data.error_code != 0) {
                        throw new Error("get list error");
                    }
                    this.transactionList = response.data.data;
                    this.loading2 = false;
                }).catch((error) => {
                    console.log(error);
                });
            },

            getCountDown() {
                if (this.blockList.length > 0) {
                    let now = parseInt((new Date().getTime() / 1000).toString());

                    // 5秒一个块自动刷新
                    if ((now - this.blockList[0].timestamp) > 5) {
                        this.getBlockList();
                        this.getTransactionList();
                    }

                    for (let i in this.blockList) {
                        let timeL = now - this.blockList[i].timestamp;
                        let mL = parseInt((timeL / 60).toString());
                        let sL = parseInt((timeL - 60 * mL).toString());
                        mL > 0 ? mL = mL + " minute" : mL = '';
                        sL > 0 ? sL = sL + " secs" : sL = '';

                        this.$set(this.blockList[i], 'm', mL);
                        this.$set(this.blockList[i], 's', sL);
                    }
                }
            },
        }

    }
</script>

<style lang="scss">
    .main {
        width: 1200px;
        margin: 0 auto;
        background-color: #f7f7f7;
        padding: 10px;
    }

    .left {
        float: left;
    }

    .right {
        float: right;
    }

    .clear {
        clear: both;
        width: 0px;
        height: 0px;
    }

    .width50 {
        width: 49%
    }

    .bgw {
        background-color: #ffffff;
    }

    .listcontent {
        width: 100%;
    }

    .blocklist {
    }

    .tranlist {
    }

    .btop {
        padding: 7px 15px;
        border-bottom: solid 3px #f7f7f7;
    }

    .btitle {
        font-size: 16px;
        line-height: 24px;
        height: 24px;
        font-weight: 400;
        margin: 0px;
    }

    .allbtn {
        font-size: 12px;
        line-height: 18px;
        cursor: pointer;
        text-decoration: none;
        border: 1px solid transparent;
        border-color: #555;
        padding: 5px 13px;
        color: #555;
    }

    .allbtn:hover {
        font-size: 12px;
        line-height: 18px;
        cursor: pointer;
        text-decoration: none;
        background-color: #555;
        border: 1px solid transparent;
        border-color: #555;
        padding: 5px 13px;
        color: #fff;
    }

    .binfo {
        padding: 10px 15px;
        margin-top: 2px;
    }

    .blockinfo {
        margin: 0px;
        line-height: 23px;
        height: 23px;
    }

    .blockinfo a {
        color: #3498db;
        text-decoration: none;
    }

    .blockinfo a:hover {
        color: #3498db;
        text-decoration: underline;
    }

    .linkblock:hover font {
        text-decoration: underline;
        text-decoration-color: #3498db;
    }
</style>
